import CONQUER from "../../CONQUER";
import PlayerInventory from "../INVENTORY/PlayerInventory";
import Shop from "./Shop";
import ShopItem from "./ShopItem";
import LOG, { log } from "../../../UTIL/LOG";
import ARRAY from "../../../UTIL/ARRAY";

class ShopTab
{
    public items        : any = [];
    public color        : string;
    public key          : string;
    public title        : string;
    public platform     : string;
    public symbol       : string;
    public type         : string;
    private id          : string;
    private Shop        : Shop;
    public sorting      : number;
    public description  : string;
 
    constructor( Shop:Shop, data:any )
    {
        this.Shop           = Shop;
        this.id             = data._id;
        this.color          = data.color;
        this.key            = data.key;
        this.title          = data.title;
        this.description    = data.description;
        this.platform       = data.platform;
        this.symbol         = data.symbol;
        this.type           = data.type;
        this.sorting        = data.sorting || 0;
 
        if( this.type === "Inventory" ) Shop.inventory.push( this );

        Shop.tabs[ this.key ] = this;
    }

    public sort()
    {
        this.items = ARRAY.sort( this.items, "value" );
    }
}

export default ShopTab;